/** Visible-time clock: hidden/cached route loaders must not expire off-screen. */
export class LoadingWatchdog {
  private startedAt: number | null = null;
  constructor(private readonly limitMs = 45000) {}
  tick(visible: boolean, now: number): boolean {
    if (!visible) { this.startedAt = null; return false; }
    if (this.startedAt === null) this.startedAt = now;
    return now - this.startedAt >= this.limitMs;
  }
}
